(function() {
    // const button = document.getElementById("sbmtbtn");
    const form = document.querySelector('form');
    const confirmationMessage = document.getElementById('confirmation-message');
    // const formContainer = document.getElementById('form-container');
    // Add the event listener to the form
    form.addEventListener('submit', function(event) {
        // Prevent default form submission
        event.preventDefault();
        // Display confirmation message
        if (confirmationMessage) confirmationMessage.style.display = 'flex';
        // Submit the form programmatically
        this.submit();
    });
})();

//# sourceMappingURL=contact.b7e40f03.js.map
